import { render } from "./carcheckgroup.vue?vue&type=template&id=08e58ec6&scoped=true&ts=true"
import script from "./carcheckgroup.vue?vue&type=script&lang=ts"
export * from "./carcheckgroup.vue?vue&type=script&lang=ts"

import "./carcheckgroup.vue?vue&type=style&index=0&id=08e58ec6&scoped=true&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e58ec6"]])

export default __exports__